import React from 'react';
import { Icon } from './Icon.js';
export const IconFilter2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M0.5 2.56836C0.500084 3.05065 0.699642 3.51117 1.05078 3.8418L4.0498 6.66602V11.25C4.0498 11.6641 4.38568 11.9999 4.7998 12H7.2002C7.61432 11.9999 7.9502 11.6641 7.9502 11.25V6.66602L10.9492 3.8418C11.3004 3.51117 11.4999 3.05065 11.5 2.56836V1.25C11.5 0.835786 11.1642 0.5 10.75 0.5H1.25C0.835787 0.5 0.5 0.835786 0.5 1.25V2.56836Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconFilter2Fill12.js.map